import type { TFunction } from "i18next"
import { z } from "zod"

export const filterSalesFormSchema = (t: TFunction) =>
  z.object({
    order_code: z.string().optional(),
    startDate: z.date({
      required_error: t("validation.startDateRequired"),
    }),
    endDate: z.date({
      required_error: t("validation.endDateRequired"),
    }),
    status: z.string().optional(),
    requestType: z.string().optional(),
    proposalNumber: z.string().optional(),
  })
export type FilterSalesFormSchemaProps = z.infer<
  ReturnType<typeof filterSalesFormSchema>
>
